import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=e5eb139c&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=e5eb139c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5eb139c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5eb139c')) {
      api.createRecord('e5eb139c', component.options)
    } else {
      api.reload('e5eb139c', component.options)
    }
    module.hot.accept("./LandingFooter.vue?vue&type=template&id=e5eb139c&scoped=true", function () {
      api.rerender('e5eb139c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingFooter.vue"
export default component.exports